import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Immutable from 'immutable';
import clsx from 'clsx';
import config from 'config/api';
import { Link } from 'react-router-dom';
import { isLoggedIn, getCurrentUser } from 'ducks/authentication';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import i18n from 'helpers/i18n';
import { footerBackgroundColor, footerLinkColor, footerColor } from 'helpers/colors';

const styles = (theme) => {
  return {
    root: {
      // backgroundColor: footerBackgroundColor,
      // color: theme.palette.primary.main,
      width: '100%',
      color: theme.palette.footer.color,
      backgroundColor: theme.palette.footer.background,
      // fontSize: '11px',
      textAlign: 'center',
      // minHeight: '118px',
      // backgroundRepeat: 'no-repeat',
      // backgroundPosition: '0 50%',
      // backgroundSize: 'contain',
      // backgroundImage: `url(${require('assets/images/'+process.env.REACT_APP_SITE+'/bubbles.png')})`,
      // backgroundImage: 'url('+require('assets/images/'+process.env.REACT_APP_SITE+'/bubbles-top.png')+')',
      // backgroundRepeat: 'no-repeat',
      // backgroundPosition: '100% 10%',
      // transition: [
      //   theme.transitions.create('background-position', {
      //     easing: theme.transitions.easing.sharp,
      //     duration: theme.transitions.duration.leavingScreen,
      //   }),
      //   theme.transitions.create('background-size', {
      //     easing: theme.transitions.easing.sharp,
      //     duration: theme.transitions.duration.leavingScreen,
      //   }),
      // ],
      // [theme.breakpoints.down('lg')]: {
      //   backgroundPosition: '50% 0',
      // },
      // [theme.breakpoints.down('md')]: {
      //   backgroundPosition: '40% 0',
      // },
      [theme.breakpoints.down('sm')]: {
        // backgroundPosition: '110% 100%',
        // backgroundSize: '30%',
      },
      [theme.breakpoints.down('xs')]: {
        // backgroundPosition: '100% 100%',
        // backgroundSize: '20%',
      },


    },
    // whiteBg: {
    //   position: 'relative',
    //   '&:before': {
    //     position: 'absolute',
    //     left: 0,
    //     top: 0,
    //     content: "' '",
    //     width: '100%',
    //     height: '100%',
    //     backgroundColor: '#fff',
    //     opacity: 0.6,
    //   },
    // },

    footerWrapper: {
      position: 'relative',
      maxWidth: 1280,
      margin: '0 auto',
      padding: 20,
    },
    logo: {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0 50%',
      backgroundSize: 'contain',
      // backgroundImage: `url(${require('assets/images/logo_footer.png')})`,
      // width: 'calc(100% - '+theme.spacing(2)+'px)',
      width: '100%',
      height: '30px',
      display: 'block',
      // margin: '0 auto',
      margin: '0 auto 0',
      [theme.breakpoints.down('sm')]: {
        backgroundPosition: '50% 50%',

      }

    },
    logoInline: {
      width: 50
    },
    gridWrapper: {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse'
      }
    },
    inline: {
      // display: 'block',
      width: 'auto',
      padding: '0 10px',
      '&:after': {
        content: ' . '
      },
      [theme.breakpoints.down('md')]: {
        // display: 'inline-block',
        padding: '0 5px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '0 5px',
      },
    },
    link: {
      textDecoration: 'none',
      textAlign: 'left',
      display: 'block',
      fontSize: '1rem',
      // fontSize: '0.6rem',
      color: theme.palette.footer.linkColor,
      '&:hover': {
        textDecoration: 'underline',
      },
      [theme.breakpoints.down('md')]: {
        // textAlign: 'center',
      }
    },
    legalNotice: {
      fontSize: '.8rem',
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(3),
        justifyContent: 'center',
        textAlign: 'center',
        // marginTop: theme.spacing(2)
      }
    },
    menu: {
      maxWidth: 1024,
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.down('md')]: {
        // marginTop: theme.spacing(2)
      }
    },
  };
};
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  render() {
    const { $$user, classes } = this.props;

    const $$menu = config.getFooterMenu($$user, {asImmutable: true});

    return (
      <div className={clsx(classes.root)}>
        <div className={classes.footerWrapper}>
          <Grid container spacing={0} alignContent="center" justify="flex-start" className={classes.gridWrapper}>
            <Grid item xs={12} md={5} className={classes.legalNotice} container alignContent="center">
              {i18n.get('footerLegalNotice')}
            </Grid>

            <Grid item xs={12} md={7} container alignItems="flex-end" justify="center" className={classes.menu}>
              {$$menu.map((m, mIdx) => {
                return <ListItem key={'fmn_'+mIdx} className={classes.inline}>
                  <ListItemText><Link className={classes.link} to={m.get('url')}>{m.get('title')}</Link></ListItemText>
                </ListItem>
              }).toArray()}
            </Grid>

          </Grid>

      </div>
    </div>
  );
}
}

function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

export default connect(mapStateToProps)(withStyles(styles)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.jsx